/**
 * A cart's or an order's discount, taken apart for its two summary lines.
 *
 * The server's `discount_amount` is everything off the goods; the bundle
 * ("frequently bought together") share of it arrives as
 * `bundle_discount_amount`. The bundle gets its own line, the code and
 * automatic discounts the rest - so nothing is shown twice and the lines
 * still add up to the total.
 */
export function splitDiscount(
  totals:
    | { discount_amount?: string | null; bundle_discount_amount?: string | null }
    | null
    | undefined,
): { bundle: number; coupon: number } {
  const all = Number(totals?.discount_amount ?? 0) || 0;
  const bundle = Math.min(all, Number(totals?.bundle_discount_amount ?? 0) || 0);
  return { bundle, coupon: Math.max(0, Math.round((all - bundle) * 100) / 100) };
}
